import React, { useEffect, useRef, useState } from "react";
import { Box, InputLabel, Typography, styled } from "@mui/material";
import Iconify from "../iconify/iconify";

const StyledWrapperBox = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  background: theme.palette.background.default,
  color: theme.palette.background.default,
}));

const StyledMenuBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "100%",
  left: 0,
  width: "100%",
  minWidth: "220px",
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
  zIndex: 55,
  borderRadius: "4px",
  border: `1px solid ${theme.palette.divider}`,

  color: theme.palette.text.secondary,
}));

const StyledItemMenuBox = styled(Box)(({ theme }) => ({
  padding: "3px",
  cursor: "pointer",
  background: theme.palette.background.default,
  "&:hover": {
    background: theme.palette.grey[800],
  },
}));

const StyledArrowBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "25px",
  height: "25px",
  borderRadius: "50%",
  background: theme.palette.background.main,
  color: theme.palette.text.secondary,
}));

const data = [
  "mdi:office-building-marker-outline",
  "mdi:greenhouse",
  "line-md:coffee-half-empty-filled-loop",
  "mdi:store-check",
  "mdi:hotel",
  "mdi:bathroom",
  "mdi:car",
  "mdi:family-room",
  "mdi:baseball-diamond-outline",
  "mdi:currency-usd",
  "mdi:currency-thb",
  "mdi:currency-eur",
  "mdi:currency-btc",
  "mdi:cash-multiple",
  "mdi:cash-100",
  "mdi:finance",
  "mdi:hand-coin",
  "mdi:calendar-month-outline",
];

const CustomSelectIcon = ({ defaultChecked, onChange = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    defaultChecked || "mdi:office-building-marker-outline"
  );

  const selectRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {}, [isOpen]);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    setSelectedOption(value);
    setIsOpen(!isOpen);
    onChange(value);
  };

  return (
    <Box>
      <Box
        ref={selectRef}
        sx={{ position: "relative", display: "inline-block" }}
      >
        <StyledWrapperBox onClick={toggleOpen}>
          <StyledArrowBox>
            <Iconify icon={selectedOption} sx={{ color: "text.primary" }} />
          </StyledArrowBox>
        </StyledWrapperBox>
        {isOpen && (
          <StyledMenuBox>
            {data.map((item, index) => (
              <StyledItemMenuBox
                key={index}
                onClick={() => handleOptionClick(item)}
              >
                <Iconify icon={item} sx={{ color: "text.primary" }} />
              </StyledItemMenuBox>
            ))}
          </StyledMenuBox>
        )}
      </Box>
    </Box>
  );
};

export default CustomSelectIcon;
